import { Outlet } from 'react-router-dom';
import { PresenceBroadcast } from '../system/PresenceBroadcast';
import { useUnreadDocumentTitle } from '../../hooks/useUnreadDocumentTitle';

/** Chat détaché : pas de sidebar ni d’en-tête cabinet, uniquement la messagerie. */
export function MessagingStandaloneLayout() {
  useUnreadDocumentTitle();

  return (
    <div className="h-screen overflow-hidden bg-white">
      <PresenceBroadcast />
      <Outlet />
    </div>
  );
}
